import React from 'react'

const Footer = () => {
  return (
    <footer id="footer">
      <div>DONG-YANG ELECTRONICS CO., LTD. WWW.DYETCO.CO.KR</div>
    </footer>
  )
}

export default Footer
